import HostnameProvider from '~/interfaces/HostnameProvider';
import Configuration from './Configuration';

export const EXPERIENCE_NAME_ADVISORS = 'Advisor Centre';

export function escapeWhiteSpaces(url: string): string {
  if (url) return url.replace(/\s/g, '%20');
  return url;
}

export function processMockedPath(mockedPath: string, unmockedPath: string): string {
  const path = Configuration.Current().mockingEnabled === true ? mockedPath : unmockedPath;
  return escapeWhiteSpaces(path);
}

export function getHomePageUrl(): string {
  // return processMockedPath('/', '/log-off');
  return processMockedPath('/', `${Configuration.Current().idpTenantUrl}/login/signout?fromURI=${Configuration.Current().onPremHostName}/eemwpnp1/public/gologin/`);
}

export function getGoHomeUrl(): string {
  return processMockedPath('/', `${Configuration.Current().onPremHostName}/wemwpn48/gohome`);
}

export function getOnCloseUrl(): string {
  // return processMockedPath('/', Configuration.Current().onPremHostName);
  return processMockedPath('/', `${Configuration.Current().idpTenantUrl}/login/signout?fromURI=${Configuration.Current().onPremHostName}`);
}

function GetDefaultHostnameProvider(): HostnameProvider {
  return {
    GetHostname: () => window.location.hostname,
  };
}

export function isLocalhost(hostnameProvider?: HostnameProvider): boolean {
  const provider = hostnameProvider || GetDefaultHostnameProvider();
  const host = provider.GetHostname();
  return !host || host === 'localhost' || host === '127.0.0.1';
}
